import React, { useEffect } from "react";
import { Route, Routes, useLocation } from "react-router-dom";

import NavBar from "./components/NavBar";
import Inicio from "./pages/Inicio";
import Nosotros from "./pages/Nosotros";
import Servicios from "./pages/Servicios";
import Novedades from "./pages/Novedades";
import TermsConditions from "./pages/TermsConditions";
import Footer from "./components/Footer"; 
import WhatsappButton from "./components/WhatsappButton"; 

const ScrollToSection = () => {
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      const id = location.hash.replace("#", "");
      const element = document.getElementById(id);
      if (element) {
        element.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    } else {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  }, [location]);

  return null;
};

const App = () => {
  return (
    <>
      <ScrollToSection />
      <NavBar />
      <div className="app-container">
        <Routes>
          <Route path="/" element={<Inicio />} />
          <Route path="/nosotros" element={<Nosotros />} />
          <Route path="/servicios" element={<Servicios />} />
          <Route path="/novedades" element={<Novedades />} />
          <Route path="/terms-conditions" element={<TermsConditions />} />
        </Routes>

        <Footer />
        <WhatsappButton />
      </div>
    </>
  );
};

export default App;